import { Injectable } from '@angular/core';
import swaggerSpec from '../../swagger-spec.json';
import Ajv from 'ajv';
import ajvErrors from 'ajv-errors';
import addFormats from 'ajv-formats';

export class ValidationError extends Error {
  constructor(message: string, options: ErrorOptions) {
    super(message, options);
    this.name = 'ValidationError';
  }
}

@Injectable({
  providedIn: 'root',
})
export class SchemaValidationService {
  private ajv: Ajv;

  private schemaMap: Record<string, any> = {};
  private schemaMap2: Record<string, any> = {};

  constructor() {
    const schemas = swaggerSpec.components?.schemas ?? {};

    this.ajv = new Ajv({ allErrors: true, strict: false, useDefaults: true, coerceTypes: true, removeAdditional: true });
    addFormats(this.ajv);
    ajvErrors(this.ajv);

    Object.entries(schemas).forEach(([key, value]) => {
      this.ajv.addSchema(value, `#/components/schemas/${key}`);
    });

    this._buildSchemaMap();
  }

  validate2(operationId: string, data: any) {
    const schema = this.schemaMap2[operationId];
    if (!schema) {
      console.warn(`[OpenApiValidationService] No schema found for operationId: ${operationId}`);
      return true;
    }

    let compiledSchema;
    let valid;
    try {
      compiledSchema = this.ajv.compile(schema);
      valid = compiledSchema(data);

      if (!valid) {
        console.warn('[SchemaValidationService] Validation failed');
        console.warn('Schema: ', schema);
        console.warn('Validation errors:', compiledSchema.errors);
      }
    } catch (error) {
      if (error instanceof ValidationError) {
        console.warn('[SchemaValidationService] Validation errors:', compiledSchema?.errors);
        // throw error;
        valid = false;
      } else {
        console.error('[SchemaValidationService] Error during validation:', error);
      }
    }

    return valid;
  }

  private _buildSchemaMap() {
    if (swaggerSpec && swaggerSpec.paths) {
      for (const path in swaggerSpec.paths) {
        // @ts-expect-error type tbd
        const pathItem = swaggerSpec.paths[path];
        for (const method in pathItem) {
          const operation = pathItem[method];
          if (operation && operation.operationId && operation.responses) {
            let successStatusCode = '';
            if (operation.responses['200']) {
              successStatusCode = '200';
            } else if (operation.responses['201']) {
              successStatusCode = '201';
            }
            if (successStatusCode && operation.responses[successStatusCode]) {
              const response = operation.responses[successStatusCode];

              const controllerId = path.split('/')[1];
              const operationId = controllerId ? `${controllerId}.${operation.operationId}` : operation.operationId;

              // Look for a JSON response – adjust if your spec uses a different media type
              if (!response.content) {
                this.schemaMap[path] = {};
                this.schemaMap2[operationId] = {};
              } else if (response.content && response.content['application/json'] && response.content['application/json'].schema) {
                this.schemaMap[path] = response.content['application/json'].schema;
                this.schemaMap2[operationId] = response.content['application/json'].schema;
              }
            }
          }
        }
      }
    }
  }
}
